import React, { useState } from 'react';
import { ExternalLink, Play } from 'lucide-react';
import { parseYoutubeUrl } from '../lib/youtube-url';
import './YoutubeVideo.css';

export function YoutubePoster({ video, title = 'Video na YouTube' }) {
  return (
    <span className="youtube-poster">
      <img
        src={`https://i.ytimg.com/vi/${video.id}/hqdefault.jpg`}
        alt={title}
        loading="lazy"
        referrerPolicy="no-referrer"
        onError={(event) => {
          event.currentTarget.style.display = 'none';
        }}
      />
      <span className="youtube-play" aria-hidden="true">
        <Play size={26} fill="currentColor" />
      </span>
      <span className="youtube-label">YouTube</span>
    </span>
  );
}

export default function YoutubeVideo({ url, title }) {
  const [started, setStarted] = useState(false);
  const video = parseYoutubeUrl(url);
  if (!video) return <p>Odkaz na video není platný.</p>;
  return (
    <div className="youtube-player">
      <div className="youtube-frame">
        {started ? (
          <iframe title={title || 'Video na YouTube'} src={`https://www.youtube-nocookie.com/embed/${video.id}?autoplay=1&rel=0${video.start ? `&start=${video.start}` : ''}`} allow="autoplay; encrypted-media; picture-in-picture; fullscreen" allowFullScreen referrerPolicy="strict-origin-when-cross-origin" />
        ) : (
          <button type="button" aria-label="Přehrát video z YouTube" onClick={() => setStarted(true)}>
            <YoutubePoster video={video} title={title} />
          </button>
        )}
      </div>
      <a className="youtube-external" href={video.url} target="_blank" rel="noopener noreferrer">
        <ExternalLink size={14} /> Otevřít na YouTube
      </a>
    </div>
  );
}
